import { createApp } from 'vue';
import App from '@/App.vue';

import '@/styles/main.css';
import '@/styles/margin.css';
import '@/styles/components.css';
import '@/styles/color.css';

import router from '@/router';
import store from '@/store';

import PrimeVue from 'primevue/config';
import Aura from '@primevue/themes/aura';

const app = createApp(App)
app.use(store);
app.use(router);
app.use(PrimeVue, {
    theme: {
        preset: Aura,
        options: {
            darkModeSelector: '.dark-mode',
            cssLayer: false,
        },
    },
});
app.mount('#app');

export default app;